import Heading1 from './Heading1';
export default Heading1;
//# sourceMappingURL=index.js.map